module.exports = __webpack_public_path__ + "img/gif.8aadb948.png";